import React, { useEffect, useState } from "react";
import Select from "react-select";
import useApiFetcher from "../../hooks/useApiFetcher";
import Modal from "../Modal/Modal";
import { FaEdit, FaRegPlusSquare } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import LoaderSpiner from "../LoaderSpiner";
import { useTheme } from "../BrandColors/Context/ThemeContext";
import { useSearchParams } from "react-router-dom";

let ProductArray = []
const Deals = () => {
    const dealershipTheme = useTheme() || "#3b82f6";

    const { apiFetcher } = useApiFetcher();
    const user = JSON.parse(localStorage.getItem("user"));

    const [deals, setDeals] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [cars, setCars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [customers, setCustomers] = useState([]);
    const [productPrices, setProductPrices] = useState({});
    const [productTaxes, setProductTaxes] = useState({})
    const [formData, setFormData] = useState({
        custId: null,
        carId: null,
        dealershipId: null,
        salesPrice: "",
        docFee: "",
        mvaFee: "",
        accessories: "",
        taxRate: "",
        taxAmount: "",
        salesTax: "",
        totalDue: "",
        tradeAllowance: "",
        tradePayoff: "",
        downpayment: "",
        rebates: "",
        tradeEquity: "",
        NetAmountDue: "",
        financeAmount: "",
        lender: "",
        lendingType: "",
        intrestedRate: "",
        daysToFirstPayment: "",
        basePayment: "",
        totalAmountFinance: "",
        totalMonthlyPayment: "",
        financeDuration: "",
        insuranceProvider: "",
        deductibleAmount: "",
        loanDetails: {
            name: "",
            miles: "",
        },
        productPrices: [{ title: "", price: "" }],
    });
    const [searchParams] = useSearchParams();
    const dealId = searchParams.get('deal');
    const users = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        ProductArray = []
        const fetchProductData = async () => {
            const response = await apiFetcher(`/multi-stepper/${users?.multiStepProcessId}`, "GET");
            response.steps.forEach((step) => {
                if (step.type === "Product Script") {
                    ProductArray.push(step.stepTitle)
                }
            })
        }
        if (users?.multiStepProcessId?.length) {
            fetchProductData()
        }
    }, [])

    const fetchDeals = async () => {
        try {
            const response = await apiFetcher(`/deals?dealershipId=${user?.dealershipId?._id}`);
            setDeals(response);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching deals:", error);
            setIsLoading(false);
        }
    };

    const fetchDropdownData = async () => {
        try {
            const carsResponse = await apiFetcher(`/cars?dealershipId=${user?.dealershipId?._id}`);
            const customersResponse = await apiFetcher(`/customers?dealershipId=${user?.dealershipId?._id}`);

            setCars(
                carsResponse.map((car) => ({
                    value: car._id,
                    label: `${car.carName} ${car.model} (${car.year})`,
                }))
            );

            setCustomers(
                customersResponse.map((customer) => ({
                    value: customer._id,
                    label: `${customer.customerName} ${customer.phoneNumber}`,
                }))
            );

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    useEffect(() => {
        fetchDeals();
        fetchDropdownData();
    }, []);

    const calculatePMT = (rate, nper, pv) => {
        if (rate === 0) return -(pv / nper);
        const monthlyRate = rate / 12 / 100;
        const pmt = -(pv * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -nper));
        return pmt;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "salesPrice", "docFee", "mvaFee", "accessories", "taxRate",
            "taxAmount", "salesTax", "totalDue", "tradeAllowance",
            "tradePayoff", "downpayment", "rebates", "tradeEquity",
            "NetAmountDue", "financeAmount", "intrestedRate",
            "daysToFirstPayment", "basePayment", "totalAmountFinance",
            "totalMonthlyPayment", "financeDuration", "deductibleAmount"
        ];

        const updatedValue = numericFields.includes(name)
            ? value === "" ? "" : parseFloat(value) || 0
            : value;

        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: updatedValue };

            const salesPrice = parseFloat(updatedData.salesPrice) || 0;
            const docFee = parseFloat(updatedData.docFee) || 0;
            const mvaFee = parseFloat(updatedData.mvaFee) || 0;
            const accessories = parseFloat(updatedData.accessories) || 0;
            const tradeAllowance = parseFloat(updatedData.tradeAllowance) || 0;
            const tradePayoff = parseFloat(updatedData.tradePayoff) || 0;
            const downpayment = parseFloat(updatedData.downpayment) || 0;
            const rebates = parseFloat(updatedData.rebates) || 0;

            const intrestRate = parseFloat(updatedData.intrestedRate) || 0;
            const term = parseFloat(updatedData.lendingType) || 0;

            const tradeEquity = tradeAllowance - tradePayoff;
            updatedData.tradeEquity = tradeEquity;

            const taxableAmount = salesPrice + docFee + accessories - tradeAllowance;
            updatedData.taxAmount = taxableAmount;

            const salesTax = taxableAmount * 0.07;
            updatedData.salesTax = salesTax;

            const totalDue = salesPrice + docFee + mvaFee + accessories + salesTax;
            updatedData.totalDue = totalDue;

            const netAmountDue = totalDue - downpayment - rebates - tradeEquity;
            updatedData.NetAmountDue = netAmountDue;

            updatedData.financeAmount = netAmountDue;

            const financeAmount = parseFloat(updatedData.financeAmount) || 0;

            let totalProductPrice = 0;
            if (ProductArray.length > 0) {
                ProductArray.forEach((productTitle) => {
                    totalProductPrice += parseFloat(productPrices[productTitle]) || 0;
                });
            }
            updatedData.totalAmountFinance = financeAmount + totalProductPrice;

            if (intrestRate && term && updatedData.totalAmountFinance > 0) {
                const basePayment = calculatePMT(intrestRate, term, updatedData.totalAmountFinance);
                updatedData.basePayment = basePayment.toFixed(2);
                updatedData.totalMonthlyPayment = basePayment.toFixed(2); // Automatically update Monthly Payment
            } else {
                updatedData.basePayment = 0;
                updatedData.totalMonthlyPayment = 0;
            }

            return updatedData;
        });
    };

    const handleNestedChange = (e, nestedField) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [nestedField]: { ...formData[nestedField], [name]: value },
        });
    };

    const handleDropdownChange = (selectedOption, { name }) => {
        setFormData({ ...formData, [name]: selectedOption?.value || null });
    };

    const openModal = (deal = null) => {
        setEditMode(!!deal);
        if (deal) {
            setFormData(deal);
            const initialProductPrices = {};
            const initialProductTaxes = {};
            deal.productPrices?.forEach((product) => {
                initialProductPrices[product.title] = product.price;
                initialProductTaxes[product.title] = product.tax; 
            });

            setProductPrices(initialProductPrices);
            setProductTaxes(initialProductTaxes); 
        } else {
            setFormData({
                custId: null,
                carId: null,
                dealershipId: null,
                dealStructure: {
                    dealType: "",
                    dealMode: "",
                },
                salesPrice: "",
                docFee: "",
                mvaFee: "",
                accessories: "",
                taxRate: "",
                taxAmount: "",
                salesTax: "",
                totalDue: "",
                tradeAllowance: "",
                tradePayoff: "",
                downpayment: "",
                rebates: "",
                tradeEquity: "",
                NetAmountDue: "",
                financeAmount: "",
                lender: "",
                lendingType: "",
                intrestedRate: "",
                daysToFirstPayment: "",
                basePayment: "",
                totalAmountFinance: "",
                totalMonthlyPayment: "",
                financeDuration: "",
                insuranceProvider: "",
                deductibleAmount: "",
                loanDetails: {
                    name: "",
                    miles: "",
                },
            });
            setProductPrices({});
            setProductTaxes({});
        }
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setFormData({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedFormData = {
                ...formData,
                productPrices: Object.keys(productPrices).map((title) => ({
                    title,
                    price: productPrices[title],
                    tax: productTaxes[title]
                })),
            };

            if (editMode) {
                await apiFetcher(`/deals/${formData._id}`, "PUT", { ...updatedFormData, dealershipId: user?.dealershipId?._id });
            } else {
                await apiFetcher("/deals", "POST", { ...updatedFormData, dealershipId: user?.dealershipId?._id });
            }
            fetchDeals();
            closeModal();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };
    
    const calculatePMT1 = (rate, term, amountFinanced) => {
        rate = rate / 100 / 12; // Convert annual rate to monthly
        if (rate === 0 || term === 0) return 0; // Prevent division by zero

        return (rate * amountFinanced) / (1 - Math.pow(1 + rate, -term));
    };

    const handleProductTaxChange = (productTitle, value) => {
        const updatedTaxes = {
            ...productTaxes,
            [productTitle]: value,
        };
        setProductTaxes(updatedTaxes);
    };

    const handleProductPriceChange = (productTitle, value) => {
        const updatedPrices = {
            ...productPrices,
            [productTitle]: value,
        };
        setProductPrices(updatedPrices);
        updateTotalAmountFinanced(updatedPrices)
    };

    const updateTotalAmountFinanced = (updatedPrices) => {
        setFormData((prevData) => {
            const baseAmountFinanced = parseFloat(prevData.financeAmount) || 0;
            const productTotal = Object.values(updatedPrices).reduce((sum, price) => sum + (parseFloat(price) || 0), 0);

            const totalAmountFinance = baseAmountFinanced + productTotal;

            const intrestRate = parseFloat(prevData.intrestedRate) || 0;
            const term = parseFloat(prevData.lendingType) || 0;

            let totalMonthlyPayment = 0;
            if (intrestRate && term && totalAmountFinance > 0) {
                totalMonthlyPayment = calculatePMT1(intrestRate, term, totalAmountFinance);
            }

            return {
                ...prevData,
                totalAmountFinance,
                totalMonthlyPayment: totalMonthlyPayment.toFixed(2),
            };
        });
    };

    const handleDelete = async (id) => {
        try {
            await apiFetcher(`/deals/${id}`, "DELETE");
            fetchDeals();
        } catch (error) {
            console.error("Error deleting customer:", error);
        }
    };

    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: 'rgba(30, 41, 59, 0.8)',
            borderColor: 'rgba(51, 65, 85, 0.5)',
            color: 'white',
            padding: '2px',
            borderRadius: '0.5rem',
            boxShadow: 'none',
            '&:hover': {
                borderColor: 'rgba(71, 85, 105, 0.8)',
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#1e293b',
            border: '1px solid rgba(51, 65, 85, 0.8)',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5)',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? 'rgba(51, 65, 85, 0.8)' : 'transparent',
            color: 'white',
            cursor: 'pointer',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'white',
        }),
        input: (provided) => ({
            ...provided,
            color: 'white',
        }),
    };

    return (
        <div className="glass-panel w-full flex flex-col p-6 animate-fade-in-up mt-8 min-h-[60vh]">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                <h2 className="text-2xl font-bold text-slate-800">Manage Deals</h2>
                
                <button
                    onClick={() => openModal()}
                    className="w-full md:w-auto btn-primary whitespace-nowrap shadow-lg flex items-center gap-2 justify-center"
                    style={{ backgroundColor: dealershipTheme }}
                >
                    Create Deal <FaRegPlusSquare size={16} />
                </button>
            </div>

            {isLoading ? (
                <div className="flex justify-center items-center py-20 flex-1">
                    <LoaderSpiner />
                </div>
            ) : deals.length === 0 ? (
                <div className="flex justify-center items-center py-16 bg-white/30 rounded-lg border border-blue-200/50">
                    <p className="text-slate-600">No deals found.</p>
                </div>
            ) : (
                <div className="w-full overflow-x-auto rounded-lg border border-blue-200/50 scrollbar-hide">
                    <table className="w-full text-left border-collapse min-w-max">
                        <thead>
                            <tr className="text-white text-sm font-semibold whitespace-nowrap" style={{ backgroundColor: dealershipTheme }}>
                                <th className="px-3 py-2.5 rounded-tl-lg">Customer</th>
                                <th className="px-3 py-2.5">Car</th>
                                <th className="px-3 py-2.5">Loan Name</th>
                                <th className="px-3 py-2.5">Base Amount Financed</th>
                                <th className="px-3 py-2.5">Total Amount Financed</th>
                                <th className="px-3 py-2.5">Total Due</th>
                                <th className="px-3 py-2.5 rounded-tr-lg">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-700/50 bg-white/30">
                            {deals?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((deal) => (
                                <tr key={deal._id} className="text-slate-700 text-sm hover:bg-white/5 transition-colors group">
                                    <td className="px-3 py-2.5 font-medium text-slate-800">{deal?.custId?.customerName || "N/A"}</td>
                                    <td className="px-3 py-2.5">{deal?.carId?.carName} {deal.carId?.model}</td>
                                    <td className="px-3 py-2.5">{deal?.loanDetails?.name || "-"}</td>
                                    <td className="px-3 py-2.5 text-primary-300">${deal?.financeAmount?.toLocaleString() || 0}</td>
                                    <td className="px-3 py-2.5 text-green-400 font-medium">${deal?.totalAmountFinance?.toLocaleString() || 0}</td>
                                    <td className="px-3 py-2.5">${deal?.totalDue?.toLocaleString() || 0}</td>
                                    <td className="px-3 py-2.5">
                                        <div className="flex items-center gap-3">
                                            <button
                                                onClick={() => openModal(deal)}
                                                className="text-primary-400 hover:text-primary-300 hover:scale-110 transition-transform p-1.5 rounded-full hover:bg-primary-900/30"
                                                title="Edit"
                                            >
                                                <FaEdit size={16} />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(deal._id)}
                                                className="text-red-400 hover:text-red-300 hover:scale-110 transition-transform p-1.5 rounded-full hover:bg-red-900/30"
                                                title="Delete"
                                            >
                                                <MdDelete size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {!isLoading && deals.length > 0 && (
                <div className="flex justify-center items-center gap-4 mt-6">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-4 py-2 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 border border-blue-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        Prev
                    </button>
                    <span className="text-slate-600 font-medium">
                        Page <span className="text-white">{currentPage}</span> of <span className="text-white">{Math.ceil(deals.length / itemsPerPage)}</span>
                    </span>
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(deals.length / itemsPerPage)))}
                        disabled={currentPage === Math.ceil(deals.length / itemsPerPage)}
                        className="px-4 py-2 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 border border-blue-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        Next
                    </button>
                </div>
            )}

            <Modal
                isOpen={modalIsOpen}
                closeModal={closeModal}
                title={editMode ? "Edit Deal" : "Create Deal"}
            >
                <div className="flex flex-col w-full max-w-4xl mx-auto p-2">
                    <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="flex flex-col gap-1.5">
                                <label htmlFor="customer" className="text-sm font-medium text-slate-700">Customer</label>
                                <Select
                                    options={customers}
                                    name="custId"
                                    value={customers.find((opt) => opt.value === formData?.custId?._id) || null}
                                    onChange={handleDropdownChange}
                                    styles={customSelectStyles}
                                    id="customer"
                                    placeholder="Select a customer..."
                                />
                            </div>

                            <div className="flex flex-col gap-1.5">
                                <label htmlFor="car" className="text-sm font-medium text-slate-700">Car</label>
                                <Select
                                    options={cars}
                                    name="carId"
                                    value={cars.find((opt) => opt.value === (formData?.carId?._id)) || null}
                                    onChange={handleDropdownChange}
                                    styles={customSelectStyles}
                                    id="car"
                                    placeholder="Select a car..."
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-2">
                            {[
                                { id: 1, label: "Sales Price", name: "salesPrice", type: "number" },
                                { id: 2, label: "Doc Fee", name: "docFee", type: "number" },
                                { id: 3, label: "MVA Fee", name: "mvaFee", type: "number" },
                                { id: 4, label: "Accessories", name: "accessories", type: "number" },
                                { id: 5, label: "Tax Rate", name: "taxRate", type: "number" },
                                { id: 6, label: "Taxable Amount", name: "taxAmount", type: "number", disabled: true },
                                { id: 7, label: "Sales Tax", name: "salesTax", type: "number", disabled: true },
                                { id: 8, label: "Total Amount Due", name: "totalDue", type: "number", disabled: true },
                                { id: 9, label: "Trade Allowance", name: "tradeAllowance", type: "number" },
                                { id: 10, label: "Trade Payoff", name: "tradePayoff", type: "number" },
                                { id: 11, label: "Downpayment", name: "downpayment", type: "number" },
                                { id: 12, label: "Rebates", name: "rebates", type: "number" },
                                { id: 13, label: "Trade Equity", name: "tradeEquity", type: "number", disabled: true },
                                { id: 14, label: "Net Amount Due", name: "NetAmountDue", type: "number", disabled: true },
                                { id: 15, label: "Base Amount Financed", name: "financeAmount", type: "number", disabled: true },
                                { id: 16, label: "Lender", name: "lender", type: "text" },
                                { id: 17, label: "Term (months)", name: "lendingType", type: "text" },
                                { id: 18, label: "Interest Rate", name: "intrestedRate", type: "number" },
                                { id: 19, label: "Day to 1st Payment", name: "daysToFirstPayment", type: "number" }, // fixed name from intrestedRate
                                { id: 20, label: "Base Payment", name: "basePayment", type: "number", disabled: true },
                                { id: 21, label: "Total Amount Financed", name: "totalAmountFinance", type: "number", disabled: true },
                                { id: 22, label: "Total Monthly Payment", name: "totalMonthlyPayment", type: "number", disabled: true },
                                { id: 23, label: "Finance Duration", name: "financeDuration", type: "number" },
                                { id: 24, label: "Insurance Provider", name: "insuranceProvider", type: "text" },
                                { id: 25, label: "Deductible Amount", name: "deductibleAmount", type: "number" }
                            ].map(({ id, label, name, type, nested, disabled }) => (
                                <div className="flex flex-col gap-1.5" key={id}>
                                    <label htmlFor={name} className="text-xs font-medium text-slate-600">{label}</label>
                                    <input
                                        id={name}
                                        type={type}
                                        name={name}
                                        value={
                                            formData && Object.keys(formData).length
                                                ? nested
                                                    ? formData[nested]?.[name] ?? ""
                                                    : formData[name] ?? ""
                                                : ""
                                        }
                                        onChange={(e) =>
                                            nested ? handleNestedChange(e, nested) : handleChange(e)
                                        }
                                        className={`input-field text-sm py-1.5 ${disabled ? 'opacity-60 bg-blue-50 cursor-not-allowed border-blue-200/30 text-slate-500' : ''}`}
                                        disabled={disabled}
                                    />
                                </div>
                            ))}
                        </div>

                        {ProductArray.length > 0 && (
                            <div className="mt-4 pt-4 border-t border-blue-200/50">
                                <h3 className="text-sm font-bold text-slate-800 mb-3">Product Settings</h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                    {ProductArray.map((productTitle) => (
                                        <React.Fragment key={productTitle}>
                                            <div className="flex flex-col gap-1.5">
                                                <label className="text-xs font-medium text-slate-600">{productTitle} Price</label>
                                                <input
                                                    type="number"
                                                    value={productPrices[productTitle] || ""}
                                                    onChange={(e) => handleProductPriceChange(productTitle, e.target.value)}
                                                    className="input-field text-sm py-1.5"
                                                />
                                            </div>
                                            <div className="flex flex-col gap-1.5">
                                                <label className="text-xs font-medium text-slate-600">{productTitle} Tax</label>
                                                <input
                                                    type="number"
                                                    value={productTaxes[productTitle] || ""}
                                                    onChange={(e) => handleProductTaxChange(productTitle, e.target.value)}
                                                    className="input-field text-sm py-1.5"
                                                />
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-blue-200/50">
                            <button 
                                type="button"
                                className="px-5 py-2 rounded-lg font-medium text-slate-700 bg-white hover:bg-blue-100 transition-colors border border-blue-200" 
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit"
                                className="px-5 py-2 rounded-lg font-medium text-white shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0"
                                style={{ backgroundColor: dealershipTheme }}
                            >
                                {editMode ? "Update" : "Create"} Deal
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default Deals;
